import IMLSRelatedFields from './IMLSRelatedFields';
import IMLSPropertySource from './IMLSPropertySource';

export default interface IMLSData {
    formFieldName: string;
    mappingName?: string;
    friendlyName?: string;
    parentFormFieldName?: string;
    formData: string | number | boolean;
    propertySource?: IMLSPropertySource[];
    relatedFields?: IMLSRelatedFields[];
}

export function newMlsData(): IMLSData {
    const mlsData: IMLSData = {
        formFieldName: '',
        formData: ''
    };
    return mlsData;
}
